var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOutreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C6 2.895 6.895 2 8 2H16C17.105 2 18 2.895 18 4V9H16V4H8V20H16V15H18V20C18 21.105 17.105 22 16 22H8C6.895 22 6 21.105 6 20V4ZM20 11V8L24 12L20 16V13H11V11H20Z",
    fill: "currentColor"
  })));
}
export default SvgSignOutreact;